import React, { Component } from "react";
import { Form, message } from "antd";
import axios from "axios";
import moment from "moment";
import {
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  SelectDocumentoItem,
  CheckItem,
} from "../../../../Components/Items";
import DatePickerItem from "../../../../Components/DatePickerItem";
import { connect } from "react-redux";
import { NOMBRES_DOCUMENTO } from "../../../../Components/SelectDocumentoItem";

class ModalTransicion extends Component {
  formRef = React.createRef();
  state = { cargando: false };

  onFinish = async (values) => {
    const { transicionActiva, leadId, headersToken, onExito, onCancel } =
      this.props;
    const { documentoId, ...camposDelForm } = values;

    const camposFormateados = { ...camposDelForm };
    Object.keys(camposFormateados).forEach((key) => {
      if (moment.isMoment(camposFormateados[key])) {
        camposFormateados[key] = camposFormateados[key].format('DD/MM/YYYY');
      }
    });

    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "leads/ejecutarTransicion",
        {
          leadId,
          transicionId: transicionActiva._id,
          documentoId: documentoId ?? null,
          campos: camposFormateados,
        },
        { headers: headersToken },
      );

      if (res.data.success === 2) {
        message.success("Transición completada.");
        onCancel();
        onExito?.();
      } else {
        message.warning(res.data.message);
      }
    } catch (error) {
      console.error("Error al ejecutar transición:", error);
      message.error("Error al completar la transición.");
    } finally {
      this.setState({ cargando: false });
    }
  };

  renderCampo(campo, index) {
    if (campo.tipo === "boolean") {
      return (
        <FormItem
          key={index}
          name={campo.nombre}
          label={campo.nombre}
          required
          valuePropName="checked"
        >
          <CheckItem />
        </FormItem>
      );
    }

    if (campo.tipo === "date") {
      return (
        <FormItem key={index} name={campo.nombre} label={campo.nombre} required>
          <DatePickerItem />
        </FormItem>
      );
    }

    if (campo.tipo === "number") {
      return (
        <FormItem
          key={index}
          name={campo.nombre}
          label={campo.nombre}
          required
          number
        >
          <InputItem type="number" />
        </FormItem>
      );
    }

    // text (default)
    return (
      <FormItem key={index} name={campo.nombre} label={campo.nombre} required>
        <InputItem />
      </FormItem>
    );
  }

  render() {
    const { visible, transicionActiva, onCancel, headersToken, empresaId } =
      this.props;
    const { cargando } = this.state;

    if (!transicionActiva) return null;

    const requiereDocumento =
      transicionActiva.documentoRequerido &&
      transicionActiva.documentoRequerido !== "Ninguno";

    return (
      <ModalItem
        title={`Transición: ${transicionActiva.nombreTransicion}`}
        visible={visible}
        onCancel={onCancel}
        footer={null}
        destroyOnClose
        spinning={cargando}
      >
        <Form ref={this.formRef} layout="vertical" onFinish={this.onFinish}>
          {requiereDocumento && (
            <FormItem
              name="documentoId"
              label={
                NOMBRES_DOCUMENTO[transicionActiva.documentoRequerido] ||
                transicionActiva.documentoRequerido
              }
              required
            >
              <SelectDocumentoItem
                tipo={transicionActiva.documentoRequerido}
                headersToken={headersToken}
                empresaId={empresaId}
              />
            </FormItem>
          )}

          {transicionActiva.campos?.map((campo, index) =>
            this.renderCampo(campo, index),
          )}

          <FormItem style={{ textAlign: "right", marginTop: 20 }}>
            <ButtonItem azul htmlType="submit" loading={cargando}>
              Completar Transición
            </ButtonItem>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalTransicion);
